import React from "react";
import { VoiceRunLogo } from "./base";

interface ProviderLogoProps {
  provider: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const IMAGE_PROVIDERS: Record<string, string> = {
  openai: "/images/model_images/openai_dark.webp",
  azure: "/images/model_images/azure_logo.svg",
  google: "/images/model_images/gemini_dark.webp",
  cartesia: "/images/model_images/cartesia_dark.webp",
  minimax: "/images/model_images/minimax_logo.webp",
  fish_audio: "/images/model_images/fish_audio_dark.webp",
  inworld: "/images/model_images/inworld_dark.webp",
  gradium: "/images/model_images/gradium_dark.webp",
  elevenlabs: "/images/model_images/elevenlabs_dark.webp",
  qwen3: "/images/model_images/qwen_dark.webp",
  xai: "/images/model_images/xai_dark.webp",
};

const SIZE_CLASSES: Record<string, string> = {
  sm: "h-4 w-auto",
  md: "h-6 w-auto",
  lg: "h-8 w-auto",
};

export const ProviderLogo: React.FC<ProviderLogoProps> = ({ provider, size = "sm", className = "" }) => {
  const key = provider.toLowerCase();
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.sm;

  if (key === "prim") {
    return <VoiceRunLogo className={`${sizeClass} ${className}`} />;
  }

  const imagePath = IMAGE_PROVIDERS[key] || "/images/logos/logo.png";

  const imageStyles = () => {
    if (key === "openai") return "brightness-75";
    if (key === "minimax") return "dark:brightness-0 dark:invert";
    if (key === "xai") return "dark:brightness-0 dark:invert";
    return "";
  };

  return (
    <img
      src={imagePath}
      alt={`${provider} logo`}
      className={`${sizeClass} object-contain ${imageStyles()} ${className}`}
      loading="lazy"
      decoding="async"
    />
  );
};
